import { render, staticRenderFns } from "./CustomerAddSidebar.vue?vue&type=template&id=735dda23&scoped=true&"
import script from "./CustomerAddSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerAddSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerAddSidebar.vue?vue&type=style&index=1&id=735dda23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735dda23",
  null
  
)

export default component.exports